import React, { useEffect, useState } from 'react'
import { Button, Col, Divider, Drawer, Input, message, Row, Select, Typography } from 'antd'
import Countries from '../../../../../utils/countrySrc'

const { Option } = Select
const { Title } = Typography

function ProductCategoryDrawer(props) {
  const [taxe, setTaxe] = useState('')
  const [countryOption, setCountry] = useState(null)
  const [countries, setCountries] = useState(null)

  useEffect(() => {
    setTaxe(props.edit ? props.editData.porcentaje : '')
    setCountry(props.edit ? props.editData.id_pais : null)

    onSearchCountry('')    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.visible])

  const onSearchCountry = () => {
    Countries.getCountries()
      .then(c => setCountries(c.data))
      .catch(err => {
        console.log(err)
        message.error('No se ha podido cargar el listado de paises')
      })
  }

  const onSaveButton = () => {
    if ([taxe, countryOption].includes('') || [taxe, countryOption].includes(null)) {
      return message.warning('Todos los campos son obligatorios')
    }
    const data = {
      country_id: countryOption,
      isv_percentage: taxe,
    }
    props.saveButton(props.edit, data, props.edit ? props.editData.id : null)
  }

  return (
    <>
      <Drawer placement="right" closable={false} onClose={props.closable} visible={props.visible} width={800}>
        <div className={'products-container-combo-tabs'}>
          <Title> {props.edit ? 'Editar impuesto de país' : 'Nuevo impuesto de país'} </Title>
          <Divider className={'divider-custom-margins-users'} />
          <Row gutter={16} className={'section-space-field'}>            
            <Col xs={12} sm={12} md={12} lg={12}>
              <div className={'title-space-field'}>Seleccionde un país*</div>
              <Select
                showSearch
                className={'single-select'}
                placeholder={'Selecciona una configuración'}
                size={'large'}
                style={{ width: '100%' }}
                value={countryOption}
                onChange={value => setCountry(value)}
                onSearch={onSearchCountry}
                getPopupContainer={trigger => trigger.parentNode}
              >
                {countries &&
                  countries.map(data => {
                    return (
                      <Option key={data.id} value={data.id}>
                        {data.name}
                      </Option>
                    )
                  })}
              </Select>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12}>
              <div className={'title-space-field'}>Impuesto*</div>
              <Input value={taxe} onChange={value => setTaxe(value.target.value)} placeholder={'Impuesto agregado'} size={'large'} type={'number'} min={0} max={99} />
            </Col>
          </Row>
        </div>
        <Divider className={'divider-custom-margins-users'} />
        <Row gutter={16}>
          <Col xs={24} sm={24} md={24} lg={24}>
            <div className="text-right">
              <div>
                <Button type={'link'} className="cancel-button" onClick={() => props.cancelButton()}>
                  Cancelar
                </Button>
                <Button htmlType="submit" className="title-tendero new-button" onClick={() => onSaveButton()}>
                  Guardar
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Drawer>
    </>
  )
}

export default ProductCategoryDrawer
